<template>
  <TemplateModal
    ref="modal"
    :edit="!create"
    :text="text"
    :send-function="onSave"
    :open-function="onOpen"
  >
    <BaseInput
      :label="t['contacts'][type === 'email' ? 'elektronnaya-pochta' : 'telefon']"
      v-model="data.value"
      :type="type === 'email' ? 'text' : 'tel'"
      :rules="rules"
    />
    <BaseInput
      :label="t['contacts']['kratkoe-opisanie']"
      v-model="data.notes"
      :rules="['required']"
    />
  </TemplateModal>
</template>

<script>
import {mapActions} from "vuex";
export default {
  name: 'WorkClientContactModal',
  props: {
    id: {
      type: [Number, String],
      default: null
    },
    create: Boolean,
    type: {
      type: String,
      default: 'phone'
    }
  },
  data: () => ({
    dialog: false,
    data: {
      value: ''
    },
  }),
  computed: {
    t() {
      return this.localStorage.translations.pages['setting-client']
    },
    text() {
      return {
        button: {
          open: this.t['contacts-dialog-add_edit-buttons'][this.type === 'email'
            ? 'dobavit-elektronnuyu-pochtu'
            : 'dobavit-telefon'],
        },
        title: {
          create: this.t['contacts-dialog-add_edit'] && this.t['contacts-dialog-add_edit'][ this.type === 'email'
            ? 'dobavlenie-elektronnoy-pochty'
            : 'dobavlenie-telefona'] || '',
          edit: this.t['contacts-dialog-add_edit'] && this.t['contacts-dialog-add_edit'][ this.type === 'email'
            ? 'redaktirovanie-elektronnoy-pochty'
            : 'redaktirovanie-telefona'] || ''
        }
      }
    },
    params() {
      return {
        limit: this.type === 'email' ? this.$route.query.address_limit : this.$route.query.phone_limit,
        page: this.type === 'email' ? this.$route.query.address_page : this.$route.query.phone_page,
        id: this.$route.params.id,
      }
    },
    rules() {
      let result = ['required', 'max50']
      if (this.type === 'email')
        result.push('email')
      return result
    }
  },
  methods: {
    ...mapActions('workClientContact', [
      'onWorkClientContactShow',
      'onWorkClientContactCreate',
      'onWorkClientContactGridEmail',
      'onWorkClientContactGridPhone',
      'onWorkClientContactUpdate',
    ]),
    async onOpen() {
      if (this.id)
        await this.onWorkClientContactShow(this.id)
          .then(res => {
            this.data = res.data.data
          })
      else
        this.data = {value: ''}
      if (this.$refs.modal && this.$refs.modal.$refs.form)
        this.$refs.modal.$refs.form.resetValidation()
    },
    async onSave() {
      this.data.work_client_id = this.$route.params.id
      this.data.type = this.type
      if (this.data.id) {
        await this.onWorkClientContactUpdate(this.data)
          .then(() => {
            if (this.type === 'email')
              this.onWorkClientContactGridEmail(this.params)
            else
              this.onWorkClientContactGridPhone(this.params)
          })
      } else {
        await this.onWorkClientContactCreate(this.data)
          .then(() => {
            if (this.type === 'email')
              this.onWorkClientContactGridEmail(this.params)
            else
              this.onWorkClientContactGridPhone(this.params)
          })
      }
    },
  },
}
</script>
